import React from 'react';
import EditorialLayout from '@/components/editorial/EditorialLayout';
import { CheckCircle2 } from 'lucide-react';
import { DraftReviewList } from '@/components/editorial/DraftReviewList';

const EditorialApprovalPage: React.FC = () => {
  return (
    <EditorialLayout>
      <div className="max-w-7xl mx-auto py-8 px-4">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold flex items-center gap-3">
            <CheckCircle2 className="w-8 h-8 text-primary" />
            Redaksjonell Godkjenning
          </h1>
          <p className="text-muted-foreground mt-1">
            Gjennomgå og godkjenn AI-genererte artikkelutkast fra RAG-systemet
          </p>
        </div>

        {/* Draft Review List */}
        <DraftReviewList />
      </div>
    </EditorialLayout>
  );
};

export default EditorialApprovalPage;
